export default "__VITE_ASSET__DMVWOuUz__"